import axios from "axios";
import { LoginData, LoginResponse } from "../types/loginData";

export async function login(loginData: LoginData): Promise<LoginResponse> {
  try {
    const apiUrl = `${process.env.REACT_APP_API_DOMAIN}/manager/login`;
    const response = await axios.post<LoginResponse>(apiUrl, loginData);
    return response.data;
  } catch (error) {
    throw new Error("Usuário ou senha incorretos!");
  }
}

export async function logout() {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("Token de autenticação não encontrado");
    }

    const apiUrl = `${process.env.REACT_APP_API_DOMAIN}/manager/logout`;
    await axios.post(
      apiUrl,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ).then( () => {
      localStorage.clear();
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      window.localStorage.clear()
    }
      
    );
  } catch (error) {
    console.error("Erro ao fazer logout:", error);
    throw new Error("Erro ao fazer logout");
  }
}

export const sendSignedUserResponse = async (
  base64ImageData: string,
  token: string
) => {
  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/assinatura`;
  const data = {
    data: base64ImageData,
  };
  try {
    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (response.status !== 200) {
      throw new Error("Erro ao adicionar a assinatura para o banco de dados.");
    }
  } catch (error) {
    console.error(
      "Erro ao adicionar a assinatura para o banco de dados:",
      error
    );
    throw error;
  }
};

export const getSignature = async (token: string) => {
  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/assinatura`;
  try {
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (response.status !== 200) {
      throw new Error("Erro ao buscar a assinatura do cliente.");
    }

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar a assinatura do cliente:", error);
    throw error;
  }
};

export const getNotifications = async (token: string) => {
  try {
    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/notificacao`;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar notificações:", error);
    throw error;
  }
};

export const markNotificationAsRead = async (
  token: string,
  notificationId: string
) => {
  try {
    await axios.put(
      `${process.env.REACT_APP_API_DOMAIN}/manager/notificacao/${notificationId}`,
      { lida_notificao: true },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      }
    );

    return true;
  } catch (error) {
    console.error("Erro ao marcar notificação como lida:", error);
    return false;
  }
};
